import { makeAutoObservable, toJS } from 'mobx';
import backgroundConfig from '@utils/backgroundConfig';

class Option {
    scale = 1;
    scaleX = false;
    scaleY = false;
    padding = 0;
    paddingBg = 'rgba(255,255,255, 100)';
    round = 10;
    shadow = 3;
    frame = 'none';
    frameMode = 'cover';
    background = 'default_1';
    align = 'center';
    waterImg = null;
    waterIndex = 1;
    rotation = 0;
    filter = {
        blur: 0,
        brightness: 100,
        contrast: 100,
        grayscale: 0,
        hueRotate: 0,
        saturate: 100,
        sepia: 0,
        invert: 0,
    };
    enableFilter = false;
    size = {
        type: 'auto',
        title: 'Auto'
    };
    frameConf = {
        width: 800,
        height: 600,
        background: {
            type: 'linear',
            from: 'left',
            to: 'right',
            stops: ['#6366f1', '#a855f7', '#ec4899']
        }
    }
    constructor() {
        makeAutoObservable(this);
    }

    get waterSvg() {
        return toJS(this.waterImg);
    }

    get mode() {
        return this.frame === 'none' || this.frame.includes('Bar') ? 'cover' : this.frameMode;
    }

    get filterString() {
        if (!this.enableFilter) return '';
        
        const { blur, brightness, contrast, grayscale, hueRotate, saturate, sepia, invert } = this.filter;
        return `blur(${blur}px) brightness(${brightness}%) contrast(${contrast}%) grayscale(${grayscale}%) hue-rotate(${hueRotate}deg) saturate(${saturate}%) sepia(${sepia}%) invert(${invert}%)`;
    }

    setScale(value) {
        this.scale = value;
    }

    setPadding(value) {
        this.padding = value;
    }

    setPaddingBg(value) {
        this.paddingBg = value;
    }

    setRound(value) {
        this.round = value;
    }

    setShadow(value) {
        this.shadow = value;
    }

    setFrame(value) {
        this.frame = value;
    }

    setFrameMode(value) {
        this.frameMode = value;
    }

    setFrameSize(width, height) {
        if (!width || !height) return;
        this.frameConf.width = width;
        this.frameConf.height = height;
    }

    setAlign(value) {
        this.align = value;
    }

    setSize(value) {
        this.size.type = value.type;
        this.size.title = value.title;
        this.setFrameSize(value.width, value.height)
    }

    setBackground(value) {
        this.background = value;
        
        if (value && value.startsWith('custom_img_')) {
            return;
        }
        
        const bgConfig = backgroundConfig[value];
        if (bgConfig) {
            if (bgConfig.fill && bgConfig.fill.type === 'pattern') {
                this.frameConf.background = [
                    {
                        type: 'solid',
                        color: bgConfig.fill.backgroundColor || '#ffffff'
                    },
                    {
                        type: 'image',
                        url: bgConfig.fill.url,
                        width: bgConfig.fill.width || 20,
                        height: bgConfig.fill.height || 20,
                        repeat: true
                    }
                ];
            } else if (bgConfig.fill && bgConfig.fill.type === 'image') {
                this.frameConf.background = {
                    type: 'image',
                    url: bgConfig.fill.url
                };
            } else {
                this.frameConf.background = bgConfig.fill;
            }
        }
    }
    toggleFlip(type) {
        if (type === 'x') {
            this.scaleX = !this.scaleX;
        }
        if (type === 'y') {
            this.scaleY = !this.scaleY;
        }
    }
    setRotation(value) {
        this.rotation = ((value % 360) + 360) % 360;
    }
    setWaterImg(value) {
        this.waterImg = value;
    }
    setWaterIndex(value) {
        this.waterIndex = value;
    }

    toggleFilter(value) {
        this.enableFilter = value !== undefined ? value : !this.enableFilter;
    }

    setFilter(type, value) {
        if (this.filter.hasOwnProperty(type)) {
            this.filter[type] = value;
        }
    }

    resetFilter() {
        this.filter = {
            blur: 0,
            brightness: 100,
            contrast: 100,
            grayscale: 0,
            hueRotate: 0,
            saturate: 100,
            sepia: 0,
            invert: 0,
        };
    }
}

const option = new Option();
export default option;
